module.exports = __webpack_public_path__ + "img/bg_top_right_corner.e6df54ab.png";